const sortBy = (key) => {
  return (a, b) => {
    return a[key].localeCompare(b[key], 'en', { sensitivity: 'base' })
  }
}

const hasValues = (obj) => {
  return Object.values(obj).every(val => !!val)
}

function camelize(string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const filterVariations = (variations, attributes) => {
  let filtered = variations
  let attr
  for (const key in attributes) {
    attr = attributes[key]
    if (attr) {
      filtered = filtered.filter((v) => {
        return v[`${key}List`]?.split('|').includes(attr)
      })
    }
  }
  return filtered
}

function getDiamondQuiltIndex(variation, style) {
  let partNumber
  if (style && style.part) {
    partNumber = style.part
  } else {
    const quiltOption = variation.options.find(option => option.added === true && option.partNumber.includes('Q'))
    partNumber = quiltOption ? quiltOption.partNumber : 'DIAQ'
  }
  const optionIndex = variation.options.findIndex(option => option.partNumber === partNumber)
  return optionIndex
}

function getDiamondQuiltOption(variation) {
  return variation.options[getDiamondQuiltIndex(variation)]
}

const calculateTax = (state, subtotal) => {
  return state === 'UT'
    ? round(subtotal * 0.0745)
    : 0
}

const round = (num) => {
  return Math.round(num * 100) / 100;
}

function getAKHIShipping(seats, prices, onlyAcc, onlySwag) {
  if (onlyAcc) {
    return onlySwag
      ? prices['OtherProductsShipping(AK/HI/Canada)'].RetailPrice
      : prices['FlexOPSShipping(AK/HI/Canada)'].RetailPrice
  }

  let shipping = 35
  const rows = Object.keys(seats).length
  if (rows > 1) {
    shipping = rows*25 + 10
  }
  return shipping
}

function getAccShipping(prices, onlySwag) {
  return onlySwag
    ? prices['OtherProductsShipping'].RetailPrice
    : prices['FlexOPSShipping'].RetailPrice
}

function getCAShipping(subtotal, onlyAcc, hasFlex) {
  if (onlyAcc && hasFlex) {
    return 15;
  }

  let shipping = 0;

  if (subtotal > 1600) {
    shipping = 142;
  } else if (subtotal > 1000) {
    shipping = 122;
  } else if (subtotal > 500) {
    shipping = 102;
  } else if (subtotal > 200) {
    shipping = 92;
  } else if (subtotal > 100) {
    shipping = 61;
  } else if (subtotal > 40) {
    shipping = 32;
  } else if (subtotal > 20) {
    shipping = 16;
  } else if (subtotal > 0) {
    shipping = 5;
  }

  return shipping;
}

function isCanada(state) {
  return state === 'AB' || state === 'BC' || state === 'MB' || state === 'NB' || state === 'NL'
  || state === 'NT' || state === 'NS' || state === 'NU' || state === 'ON' || state === 'PE'
  || state === 'QC' || state === 'SK' || state === 'YT';
}

function getCountry(state) {
  return isCanada(state) ? 'CA' : 'US';
}

function calculateShipping(state, seats, subtotal, freeShipping48, prices, onlyAcc, hasFlex) {
  if (state === 'AK' || state === 'HI') {
    return getAKHIShipping(seats, prices, onlyAcc, !hasFlex)
  } else if (isCanada(state)) {
    return getCAShipping(subtotal, onlyAcc, hasFlex)
  } else if (onlyAcc) {
    return getAccShipping(prices, !hasFlex)
  } else if (freeShipping48 || subtotal >= 400) {
    return 0
  }
  return 25
}

const requiredRule = [
  v => !!v || 'This field is required',
]

const positions = function() {
  return [
    'front',
    'rear',
    'third'
  ]
}

export {
  sortBy,
  hasValues,
  camelize,
  capitalize,
  getCountry,
  calculateShipping,
  calculateTax,
  getDiamondQuiltIndex,
  getDiamondQuiltOption,
  filterVariations,
  requiredRule,
  positions
}

